import {
  $applyNodeReplacement,
  DecoratorNode,
  EditorConfig,
  LexicalNode,
  NodeKey,
  SerializedLexicalNode,
  Spread,
} from "lexical";

export type SerializedHtmlNode = Spread<
  {
    html: string;
  },
  SerializedLexicalNode
>;

export class HtmlNode extends DecoratorNode<JSX.Element> {
  __html: string;

  static getType(): string {
    return "html";
  }

  static clone(node: HtmlNode): HtmlNode {
    return new HtmlNode(node.__html, node.__key);
  }

  constructor(html: string, key?: NodeKey) {
    super(key);
    this.__html = html;
  }

  createDOM(config: EditorConfig): HTMLElement {
    const span = document.createElement("span");
    const className = config.theme.html;
    if (className) {
      span.className = className;
    }
    return span;
  }

  updateDOM(): false {
    return false;
  }

  getHtml(): string {
    return this.__html;
  }

  static importJSON(serializedNode: SerializedHtmlNode): HtmlNode {
    const { html } = serializedNode;
    return $createHtmlNode(html);
  }

  exportJSON(): SerializedHtmlNode {
    return {
      html: this.__html,
      type: "html",
      version: 1,
    };
  }

  decorate(): JSX.Element {
    return (
      <span
        dangerouslySetInnerHTML={{ __html: this.__html }}
        className="editor-paragraph-span"
      />
    );
  }
}

export function $createHtmlNode(html: string): HtmlNode {
  return $applyNodeReplacement(new HtmlNode(html));
}

export function $isHtmlNode(
  node: LexicalNode | null | undefined
): node is HtmlNode {
  return node instanceof HtmlNode;
}
